import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useInventoryBatchList(params) {
  return useSWR(
    params?.warehouse && params?.product && params?.productModel
      ? {
          path: `/api/v1/inventories/inventory-batches`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useInventoryBatchList;
